import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { VisitPricingTypes, VisitTypes } from "../constants";
import { type VisitWithCaseData } from "../types";
import { getRegularPerHourVisitTimeRangeLabel } from "../utils";

interface VisitTimeLabelProps {
  visit: VisitWithCaseData;
}

function getVisitTimeByVisitAndPricingType(visit: VisitWithCaseData) {
  const { pricingType, type } = visit.attributes;
  if (type === VisitTypes.REGULAR && pricingType === VisitPricingTypes.PER_HOUR) {
    return getRegularPerHourVisitTimeRangeLabel(visit);
  }

  return "Flexible";
}

export function VisitTimeLabel(props: VisitTimeLabelProps) {
  const { visit } = props;
  const { pricingType, type, estimatedDuration } = visit.attributes;
  const shouldShowDuration =
    pricingType === VisitPricingTypes.PER_HOUR &&
    type === VisitTypes.REGULAR &&
    isDefined(estimatedDuration);

  return (
    <Stack direction="row" alignItems="flex-end" spacing={2}>
      <Text semibold variant="h6">
        {getVisitTimeByVisitAndPricingType(visit)}
      </Text>
      {shouldShowDuration && (
        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
          {estimatedDuration}h
        </Text>
      )}
    </Stack>
  );
}
